import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../providers/AuthContext';
import { isEmployeePortalUser } from '../../../shared/lib/employeePortal';

/**
 * Hanya pengguna karyawan (bukan admin/instructor). Gabung dengan ProtectedRoute untuk auth.
 */
export const RequireEmployeePortal = () => {
    const { user, isAuthenticated } = useAuth();
    const location = useLocation();

    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (!isEmployeePortalUser(user)) {
        return <Navigate to="/" replace />;
    }

    return <Outlet />;
};
